/**
 * How many communities one batch push may name — Python's
 * `SPEC_PUSH_COMMUNITY_IDS_MAX` (`server/app/api/contracts/specifications.py`,
 * #1093 owner D2 = a), about 8x the largest base on the load. Here in `lib/`
 * because both graphs carry it: the start's browser schema
 * (`@/api/contracts/specifications`) and its internal-wire face
 * (`@/server/data/internal-api/specifications`), whose drift test pins it to
 * Python's `maxItems`.
 */
export const SPEC_PUSH_COMMUNITY_IDS_MAX = 1000;
